import { postJsMessage } from '../../bridge';
import API from '../../api';
import { isAvailable } from '../utils';
import { NativeAPIResponseMessage } from '@zoom/hybrid-jsbridge';
import { PostMessageOption } from 'types/index';

type PermissionStatus = 'granted' | 'denied' | 'undetermined';

type QueryPermissionRequest = {
  queryCamera: boolean;
  queryMicrophone: boolean;
};

type PermissionResponse = {
  camera: PermissionStatus;
  microphone: PermissionStatus;
};
/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * permissions.queryPermission
 *
 * [PLATFORM]
 * mac        6.4.0+
 * windows    6.4.0+
 * linux      6.4.0+
 * ios        6.4.0+
 * android    6.4.0+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export function queryPermission(
  query: QueryPermissionRequest,
  options?: PostMessageOption
): Promise<NativeAPIResponseMessage<PermissionResponse>> {
  return isAvailable('permissions.queryPermission').then(() => {
    return postJsMessage<QueryPermissionRequest, PermissionResponse>(
      API.queryPermission,
      query,
      options
    );
  });
}

type ResetPermissionRequest = {
  resetCamera: boolean;
  resetMicrophone: boolean;
};

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * permissions.resetPermission
 *
 * [PLATFORM]
 * mac        6.4.0+
 * windows    6.4.0+
 * linux      6.4.0+
 * ios        6.4.0+
 * android    6.4.0+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export function resetPermission(
  resetOption: ResetPermissionRequest,
  options?: PostMessageOption
): Promise<NativeAPIResponseMessage<PermissionResponse>> {
  return isAvailable('permissions.resetPermission').then(() => {
    return postJsMessage<ResetPermissionRequest, PermissionResponse>(
      API.resetPermission,
      resetOption,
      options
    );
  });
}

export default {
  queryPermission,
  resetPermission,
};
